import React from 'react';
import {
  CircularProgress,
  Box,
  ButtonProps,
  Button as MUIButton,
} from '@mui/material';
import { CustomSizes } from './loading-types';

interface ButtonDefaultProps extends ButtonProps {
  isLoading?: boolean | undefined;
}

const Loading: React.FC = () => (
  <Box marginRight={2} display="flex" color={'white'} alignItems="center">
    <CircularProgress size={18} color='inherit' />
  </Box>
);

export const ButtonDefault: React.FC<
  ButtonDefaultProps & { component?: React.ElementType }
> = ({
  children,
  component,
  size = 'large',
  variant = 'contained',
  isLoading,
  disabled,
  ...rest
}) => {
  return (
    <MUIButton
      disabled={isLoading || disabled}
      disableElevation
      variant={variant}
      component={component || 'button'}
      color="primary"
      size={size}
      style={{ height: 45, minWidth: 140 }}
      {...rest}
    >
      {isLoading ? <Loading /> : children}
    </MUIButton>
  );
};
